export /* @ngInject */
function main() {
    this.$inject('$httpBackend', '$animate');
}
